import keys from 'lodash-es/keys'
import * as React from 'react'

import { config } from '../../../../common/config'
import { ISeoBlock } from '../../../../typings/seoMetadata'
import MarketingBlock from '../marketingBlock'
import PageSection from '../pageSection'

import * as styles from './marketingSection.module.css'

interface IProps {
  blocks: {
    [key: string]: ISeoBlock
  }
}

const MarketingSection = ({ blocks }: IProps) => {
  const items = keys(blocks).map((key, index) => {
    const post = blocks[key]
    return (
      <div className={styles.block} key={index}>
        <MarketingBlock
          imgSrc={`${
            config.assets.PUBLIC_PATH
          }/images/home-page/marketing/${key}.png`}
          title={post.title}
          description={post.text}
        />
      </div>
    )
  })

  return (
    <div
      id="marketing-section"
      className={styles.root}
      data-test-selector="marketingSection"
    >
      <PageSection borderTop spaceBottom>
        <div className={styles.blockContainer}>{items}</div>
      </PageSection>
    </div>
  )
}

export default MarketingSection
